import { useState } from "react";

export default function FAQ({ data = [] }) {
    const [openIndex, setOpenIndex] = useState(0);

    const toggle = (idx) => {
        setOpenIndex(openIndex === idx ? null : idx);
    };

    return (
        <section className="max-w-4xl mx-auto border border-blue-700 rounded text-black mt-8 mb-20">
            {/* Header */}
            <div className="text-center py-4">
                <p className="text-yellow-500 text-sm font-semibold uppercase">FAQ</p>
                <h2 className="font-bold text-2xl text-black">Ask Us Anything</h2>
            </div>

            {/* FAQ Items */}
            {data.map((item, idx) => {
                const isOpen = openIndex === idx;

                return (
                    <div
                        key={idx}
                        className={`border border-blue-700 px-4 py-3 cursor-pointer transition-all duration-300 ${idx !== data.length - 1 ? "border-b-0" : ""
                            }`}
                        onClick={() => toggle(idx)}
                    >
                        <div className="flex items-center space-x-2">
                            <span className="text-yellow-500">
                                {isOpen ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M20 12H4" />
                                    </svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                                    </svg>
                                )}
                            </span>
                            <h4 className="font-semibold text-blue-900">{item.q}</h4>
                        </div>

                        {isOpen && (
                            <p className="mt-2 text-sm text-gray-700 border-t border-blue-700 pt-2">
                                {item.a}
                            </p>
                        )}
                    </div>
                );
            })}
        </section>
    );
}
